export const PrimeTvChannels = [
    { name: 'Qazaqstan', isHD: true },
    { name: 'Хабар', isHD: true },
    { name: '24KZ', isHD: true },
    { name: 'Balapan', isHD: false },
    { name: 'Abai TV', isHD: false },
    { name: 'Qazsport', isHD: true },
    { name: 'Jibek Joly', isHD: true },
    { name: 'МИР', isHD: false },
    { name: 'ASTANA TV', isHD: false },
    { name: 'Almaty', isHD: false },
    { name: 'Первый канал. Евразия', isHD: false },
    { name: 'КТК', isHD: true },
    { name: '31 канал', isHD: true },
    { name: 'Седьмой канал', isHD: false },
    { name: 'Atameken Business', isHD: true },
    { name: 'НТК', isHD: false },
    { name: 'Sport Plus Qazaqstan', isHD: true },
    { name: 'Turkistan', isHD: false },
    { name: 'Той Думан', isHD: false },
    { name: 'MUNARA TV', isHD: false },
    { name: 'Мир 24', isHD: false },
    { name: 'Новое телевидение', isHD: true },
    { name: 'Hit TV', isHD: false },
    { name: 'SHOW KZ', isHD: true },
    { name: 'Көктем SD', isHD: false },
    { name: 'Qonaev Media', isHD: false },
    { name: 'Ключ', isHD: true },
    { name: 'Семейный Теле Сигнал (СТС)', isHD: false },
    { name: 'Большая пятница', isHD: false },
    { name: 'Камеди Казахстан', isHD: true },
    { name: 'Домашний очаг', isHD: false },
    { name: 'Развлекательное ТВ (РЕН ТВ)', isHD: false },
    { name: 'Время', isHD: false },
    { name: 'Россия К', isHD: false },
    { name: 'Родное кино', isHD: false },
    { name: 'Наше новое кино', isHD: true },
    { name: 'Русский Иллюзион', isHD: true },
    { name: 'Иллюзион+', isHD: true },
    { name: 'Дом кино Премиум', isHD: true },
    { name: 'Дом кино', isHD: false },
    { name: 'viju TV1000 русское', isHD: true },
    { name: 'Hollywood', isHD: false },
    { name: 'НСТВ', isHD: false },
    { name: 'Bollywood', isHD: true },
    { name: 'Индийское кино', isHD: false },
    { name: 'Кино Сериал', isHD: true },
    { name: 'Кино Драма', isHD: true },
    { name: 'Киносемья', isHD: true },
    { name: 'Кинокомедия', isHD: true },
    { name: 'Киномикс', isHD: true },
    { name: 'Кинохит', isHD: true },
    { name: 'Кинопремьера', isHD: true },
    { name: 'Мужское кино', isHD: true },
    { name: 'Киносвидание', isHD: true },
    { name: 'Киноужас', isHD: true },
    { name: 'Киносерия', isHD: true },
    { name: 'viju TV1000', isHD: true },
    { name: 'viju TV1000 аction', isHD: true },
    { name: 'Синема', isHD: false },
    { name: 'FOX', isHD: true },
    { name: 'Flix Snip', isHD: true },
    { name: 'Мосфильм. Золотая коллекция', isHD: true },
    { name: 'Plan B', isHD: true },
    { name: 'КиноБоевик', isHD: true },
    { name: 'Премиум Кино', isHD: true },
    { name: 'Мировое Кино', isHD: true },
    { name: 'Семейное Кино', isHD: true },
    { name: 'Amedia 1', isHD: true },
    { name: 'Amedia 2', isHD: false },
    { name: 'Dorama', isHD: true },
    { name: 'Amedia Premium', isHD: true },
    { name: 'Amedia hit', isHD: true },
    { name: 'Start Air', isHD: true },
    { name: 'Start World', isHD: true },
    { name: 'NickToons', isHD: true },
    { name: 'Da Vinci', isHD: false },
    { name: 'Ti Ji', isHD: false },
    { name: 'Gulli Girl', isHD: false },
    { name: 'О!', isHD: false },
    { name: 'Карусель', isHD: false },
    { name: 'Мульт', isHD: true },
    { name: 'Nick Jr', isHD: false },
    { name: 'Nickelodeon', isHD: true },
    { name: 'Cartoon Classics', isHD: true },
    { name: 'Ducktv', isHD: true },
    { name: 'Мультиландия', isHD: true },
    { name: 'Победа', isHD: false },
    { name: 'History', isHD: true },
    { name: 'viju History', isHD: true },
    { name: 'viju Explore', isHD: true },
    { name: 'ТОЧКА.РФ', isHD: true },
    { name: 'Техно 24', isHD: false },
    { name: 'Авто 24', isHD: true },
    { name: 'Curiosity Stream', isHD: true },
    { name: 'National Geographic', isHD: true },
    { name: 'Nat Geo WILD', isHD: true },
    { name: 'viju Nature', isHD: true },
    { name: 'Инфоканал', isHD: false },
    { name: 'Моя планета', isHD: true },
    { name: 'Поехали!', isHD: false },
    { name: 'Рыбалка и охота', isHD: true },
    { name: 'Туран (тест)', isHD: false },
    { name: 'Кухня', isHD: true },
    { name: 'Телекафе', isHD: false },
    { name: 'Загородная жизнь', isHD: true },
    { name: 'Бобёр', isHD: false },
    { name: 'Мужской', isHD: true },
    { name: 'Epik!', isHD: true },
    { name: 'Travelxp', isHD: true },
    { name: 'ЖИВИ!', isHD: true },
    { name: 'Лапки Live', isHD: false },
    { name: 'MMA-TV.COM', isHD: true },
    { name: 'Бокс ТВ', isHD: false },
    { name: 'Q Arena', isHD: true },
    { name: 'Матч! Планета', isHD: false },
    { name: 'Extreme', isHD: true },
    { name: 'KHL', isHD: false },
    { name: 'KHL Prime', isHD: true },
    { name: 'viju+ Sport', isHD: true },
    { name: 'Q League', isHD: true },
    { name: 'Setanta Qazaqstan', isHD: true },
    { name: 'Setanta Sports 1', isHD: true },
    { name: 'Setanta Sports 2', isHD: true },
    { name: 'Q Football', isHD: true },
    { name: 'Музыка Первого', isHD: false },
    { name: 'FON MUSIC', isHD: false },
    { name: 'Шансон', isHD: false },
    { name: 'Classic Music', isHD: true },
    { name: 'Fashion&LifeStyle', isHD: true },
    { name: 'HOME 4K', isHD: false },
    { name: 'Museum 4K', isHD: false },
    { name: 'MyZen 4K', isHD: false },
    { name: 'Инсайт ТВ 4K', isHD: false },
    { name: 'Fashion&Style 4K', isHD: false },
    { name: 'QUADRO 4К', isHD: false },
    { name: 'Travelxp 4K', isHD: false },
    { name: 'AQTOBE', isHD: false },
    { name: 'MANGYSTAY', isHD: false },
    { name: 'AQJAIYQ', isHD: false },
    { name: 'ATYRAY', isHD: false },
    { name: 'РИКА-ТВ', isHD: false },
    { name: 'Caspian News', isHD: false },
    { name: 'ALTAI', isHD: false },
    { name: 'ERTIS', isHD: false },
    { name: 'Ирбис ТВ', isHD: false },
    { name: 'SEMEI', isHD: false },
    { name: 'Жетысу', isHD: true },
    { name: 'QYZYLJAR', isHD: false },
    { name: 'KÓKSHE', isHD: false },
    { name: 'QOSTANAI', isHD: false },
    { name: 'SARYARQA', isHD: false },
    { name: 'Алау ТВ', isHD: false },
    { name: '5 канал', isHD: false },
    { name: 'Ulytau', isHD: false },
    { name: 'Aqsham TV', isHD: false },
    { name: 'Твоё ТВ', isHD: false },
    { name: 'JAMBYL', isHD: false },
    { name: 'QYZYLORDA', isHD: false },
    { name: 'Отырар', isHD: false },
    { name: 'ONTUSTIK', isHD: false },
    { name: 'Айғак', isHD: false },
    { name: 'Тұран ТВ', isHD: false },
    { name: 'Ассамблея ТВ', isHD: false },
    { name: 'QADAM TV', isHD: false },
    { name: 'HAN-TV', isHD: false },
];
